import { Contract, ContractTenant } from '../../../../../common/validations'
import { TenantChoiceState } from './TenantChoice'
import { isContractChangePending } from './isContractChangePending'
import { resolveTenantStatusLabel } from './resolveTenantStatusLabel'

export const lockChoiceByTenantStatus = (
  contract: Contract,
  tenants: ContractTenant[],
  tenant: ContractTenant,
  choice: TenantChoiceState
): TenantChoiceState => {
  const statusLabel = resolveTenantStatusLabel(
    contract,
    tenant,
    isContractChangePending(contract, tenants)
  )

  return statusLabel ? { type: 'locked', label: statusLabel } : choice
}
